/**
 * Passkey (WebAuthn) login. Email must be entered in the login form (profile or header).
 */
(function () {
    if (!window.PublicKeyCredential) return;

    var LAST_EMAIL_KEY = 'carbuy_last_login_email';

    function base64UrlToArrayBuffer(str) {
        str = String(str).replace(/-/g, '+').replace(/_/g, '/');
        var pad = str.length % 4;
        if (pad) str += '===='.slice(0, 4 - pad);
        var binary = atob(str);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        return bytes.buffer;
    }

    function arrayBufferToBase64Url(buffer) {
        var bytes = new Uint8Array(buffer);
        var binary = '';
        for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    function getCsrfPayload() {
        var name = document.querySelector('meta[name="csrf-token-name"]');
        var hash = document.querySelector('meta[name="csrf-token"]');
        var payload = {};
        if (name && name.content) payload[name.content] = hash && hash.content ? hash.content : '';
        return payload;
    }

    function updateCsrfFromResponse(response) {
        if (window.CSRFHelper && response && typeof response.csrf_name !== 'undefined' && typeof response.csrf_hash !== 'undefined') {
            window.CSRFHelper.updateCSRFMeta(response);
        }
    }

    function showError(msg, form) {
        var box = form ? form.querySelector('.auth-warning-messages, .header-auth-warning-messages') : null;
        var msgEl = form ? form.querySelector('.auth-message-warning-email, .header-auth-message-warning-email') : null;
        if (!box && !form) {
            box = document.querySelector('.auth-warning-messages, .header-auth-warning-messages');
            msgEl = document.querySelector('.auth-message-warning-email, .header-auth-message-warning-email');
        }
        if (box && msgEl) {
            msgEl.textContent = msg || 'Passkey login failed.';
            msgEl.style.display = 'block';
            box.style.display = 'block';
        }
    }

    function saveLastEmail(email) {
        try {
            if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) localStorage.setItem(LAST_EMAIL_KEY, email);
        } catch (e) {}
    }

    function prefillLastEmail() {
        try {
            var email = localStorage.getItem(LAST_EMAIL_KEY);
            if (!email) return;
            var inputs = document.querySelectorAll('input[name="form-auth-email"]');
            for (var i = 0; i < inputs.length; i++) {
                if (!inputs[i].value || inputs[i].value.trim() === '') inputs[i].value = email;
            }
        } catch (e) {}
    }

    document.addEventListener('DOMContentLoaded', function () {
        prefillLastEmail();

        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest ? e.target.closest('.passkey-login-btn') : null;
            if (!btn) return;

            var form = btn.closest('form');
            var emailInput = form ? form.querySelector('input[name="form-auth-email"]') : null;
            var email = emailInput ? emailInput.value.trim() : '';
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                showError(document.documentElement.lang === 'lv' ? 'Ievadiet e-pastu, lai pierakstītos ar passkey.' : 'Enter your email to sign in with passkey.', form);
                return;
            }

            var payload = getCsrfPayload();
            payload.email = email;

            fetch('/profile/auth/passkey/assertion-options', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
                body: new URLSearchParams(payload)
            })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    updateCsrfFromResponse(data);
                    if (!data.success || !data.options || !data.options.publicKey) {
                        showError(data.message || 'Passkey not available for this account.', form);
                        return;
                    }
                    var pubKey = data.options.publicKey;
                    var challenge = pubKey.challenge;
                    if (typeof challenge === 'string') {
                        pubKey.challenge = base64UrlToArrayBuffer(challenge);
                    }
                    if (pubKey.allowCredentials && Array.isArray(pubKey.allowCredentials)) {
                        pubKey.allowCredentials = pubKey.allowCredentials.map(function (c) {
                            return {
                                type: c.type || 'public-key',
                                id: typeof c.id === 'string' ? base64UrlToArrayBuffer(c.id) : c.id,
                                transports: c.transports
                            };
                        });
                    }
                    return navigator.credentials.get({ publicKey: pubKey });
                })
                .then(function (credential) {
                    if (!credential) return;
                    var verifyPayload = getCsrfPayload();
                    verifyPayload.credentialId = credential.id;
                    verifyPayload.clientDataJSON = arrayBufferToBase64Url(credential.response.clientDataJSON);
                    verifyPayload.authenticatorData = arrayBufferToBase64Url(credential.response.authenticatorData);
                    verifyPayload.signature = arrayBufferToBase64Url(credential.response.signature);
                    return fetch('/profile/auth/passkey/verify-assertion', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
                        body: new URLSearchParams(verifyPayload)
                    });
                })
                .then(function (r) { return r && r.json ? r.json() : null; })
                .then(function (data) {
                    if (data && data.success && data.redirect) {
                        saveLastEmail(email);
                        if (window.CSRFHelper && data.csrf_name && data.csrf_hash) window.CSRFHelper.updateCSRFMeta(data);
                        window.location.href = data.redirect;
                    } else if (data && !data.success) {
                        showError(data.message || 'Verification failed.', form);
                    }
                })
                .catch(function (err) {
                    if (err && err.name === 'NotAllowedError') return;
                    showError(document.documentElement.lang === 'lv' ? 'Passkey ielogošanās neizdevās.' : 'Passkey sign-in failed.', form);
                });
        });
    });

    window.CarbuyPasskeyLogin = { saveLastEmail: saveLastEmail, prefillLastEmail: prefillLastEmail };
})();
